import React from "react";
import { Link } from "react-router-dom";
import bg1 from "../Assets/blog/bg1.JPG";
import bg2 from "../Assets/blog/bg2.JPG";
import bg3 from "../Assets/blog/bg3.JPG";
import bg4 from "../Assets/blog/bg4.JPG";
import Aos from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

const BlogSection = () => {
  const navigate = useNavigate();
  const blogPosts = [
    {
      imgSrc: bg1,
      title: "Blog Post 1",
      description: "Lorem ipsum dolor sit amet consectetur",
    },
    {
      imgSrc: bg2,
      title: "Blog Post 2",
      description: "Lorem ipsum dolor sit amet consectetu",
    },
    {
      imgSrc: bg3,
      title: "Blog Post 3",
      description: "Lorem ipsum dolor sit amet consectetu",
    },
    {
      imgSrc: bg4,
      title: "Blog Post 4",
      description: "Lorem ipsum dolor sit amet consectetu",
    },
  ];

  const blogPostSlice = blogPosts.slice(0, 4);

  return (
    <div className='my-8 md:my-14 lg:my-20'>
      <div className=' p-4 flex flex-col space-y-5 lg:space-y-9 lg:container lg:mx-auto lg:max-w- '>
        <h1 className=' text-4xl text-right font-extrabold'>
          <span className='border-b-4 border-b-green-600'>News</span> Feed
        </h1>
        {/* <!-- blog posts --> */}
        {/* <h1 className='text-center text-md font-bold text-neutral-400'>
          Some amazing blog posts that are written by even more amazing people.
        </h1> */}

        <div className='grid grid-cols-1 md:mx-20 slg:mx-2 slg:grid-cols-2 gap-4 xl:gap-20   justify-between'>
          {/* {blogs.map((blog, index) => (
            <div className='flex flex-col space-y-3'>
              <img
                src={blog.image}
                alt=''
                className='h-[25rem] object-cover '
              />
              <h1 className='font-bold text-sm'>{blog.title}</h1>
              <p className=' text-yellow-300 font-bold text-xl'>
                {blog.description}
              </p>
              <Link className='text-sm underline text-green-600 '>
                Read Post
              </Link>

              <h1 className="border-b-2"></h1>
            </div>
          ))} */}
        </div>

        <div className='grid grid-cols-1 gap-4'>
          {blogPostSlice.map((post, index) => (
            <div
              onClick={() => navigate("/read-post")}
              key={index} // Use a unique key for each element in the list
              className={`hover:scale-95 transition duration-1000 ${
                index % 2 === 0 ? "col-span-2" : "" // Alternate between col-span-2 and default width
              } h-[${
                index % 2 === 0 ? "40rem" : "14rem"
              }] md:h-[30rem] relative`}
            >
              <Link>
                <img
                  src={post.imgSrc}
                  alt=''
                  className={`h-[${
                    index % 2 === 0 ? "30rem" : "14rem"
                  }] md:h-[30rem] object-cover w-full`}
                />

                <div className='absolute top-0 p-4 md:p-8 bg-black h-full w-full bg-opacity-30'>
                  <div className='flex h-full items-end'>
                    <div className='text-white font-bold text-xl'>
                      <h1 className='border-b-2 border-b-green-500'>
                        {post.title}
                      </h1>
                      <h2
                        className={`text-sm ${
                          index % 2 === 0 ? "md:text-lg" : ""
                        }`}
                      >
                        {post.description}
                      </h2>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogSection;

// import React from "react";
// import { Link } from "react-router-dom";
// import img1 from "../Assets/bg1.jpg";
// import img2 from "../Assets/bg2.jpg";
// import img3 from "../Assets/bg-3.jpg";
// import img4 from "../Assets/bg-4.jpg";
// import img5 from "../Assets/bg1.jpg";
// import Aos from "aos";
// import "aos/dist/aos.css";

// const BlogSection = () => {

//   return (
//     <div className='my-8 md:my-14 lg:my-20'>
//       <div className=' p-4 flex flex-col space-y-5 lg:space-y-9 lg:container lg:mx-auto lg:max-w- '>
//         <h1 className=' text-4xl text-right font-extrabold'>
//           <span className='border-b-4 border-b-green-600'>News</span> Feed
//         </h1>
//         {/* <!-- blog posts --> */}
//         {/* <h1 className='text-center text-md font-bold text-neutral-400'>
//           Some amazing blog posts that are written by even more amazing people.
//         </h1> */}

//         <div className='grid grid-cols-1 md:mx-20 slg:mx-2 slg:grid-cols-2 gap-4 xl:gap-20   justify-between'>
//           {/* {blogs.map((blog, index) => (
//             <div className='flex flex-col space-y-3'>
//               <img
//                 src={blog.image}
//                 alt=''
//                 className='h-[25rem] object-cover '
//               />
//               <h1 className='font-bold text-sm'>{blog.title}</h1>
//               <p className=' text-yellow-300 font-bold text-xl'>
//                 {blog.description}
//               </p>
//               <Link className='text-sm underline text-green-600 '>
//                 Read Post
//               </Link>

//               <h1 className="border-b-2"></h1>
//             </div>
//           ))} */}
//         </div>

//         <div className='grid grid-cols-1 gap-4'>
//           <div className='grid grid-cols-2 lg:grid-cols-4 w-full gap-4'>
//             <div
//               // data-aos='flip-up'
//               className=' col-span-2 hover:scale-95 transition duration-1000 h-[40rems] w-full relative'
//             >
//               <Link>
//                 <img
//                   src={img2}
//                   alt=''
//                   className='h-[30rem] object-cover w-full'
//                 />
//                 <div className='absolute top-0 p-4 md:p-8 lg:p-14 bg-black h-full w-full bg-opacity-30'>
//                   <div className='flex  h-full  items-end'>
//                     <div className='text-white font-bold text-xl'>
//                       <h1 className='border-b-2 border-b-green-500'>
//                         Blog Post 1
//                       </h1>
//                       <h2 className='text-sm'>
//                         Lorem ipsum dolor sit amet consectetur{" "}
//                       </h2>
//                     </div>
//                   </div>
//                 </div>
//               </Link>
//             </div>

//             <div className=' hover:scale-95 transition duration-1000 h-[14rem] md:h-[30rem] relative'>
//               <Link>
//                 <img
//                   src={img1}
//                   alt=''
//                   className='h-[14rem] md:h-[30rem] object-cover w-full'
//                 />

//                 <div className='absolute top-0 p-4 md:p-8 bg-black h-full w-full bg-opacity-30'>
//                   <div className='flex  h-full  items-end'>
//                     <div className='text-white font-bold text-xl'>
//                       <h1 className='border-b-2 border-b-green-500'>
//                         Blog Post 1
//                       </h1>
//                       <h2 className='text-sm'>
//                         Lorem ipsum dolor sit amet consectetu
//                       </h2>
//                     </div>
//                   </div>
//                 </div>
//               </Link>
//             </div>
//             {/* Post 3  */}
//             <div className=' hover:scale-95 transition duration-1000 ease-in-out h-[14rem] md:h-[30rem] w-full relative'>
//               <Link>
//                 <img
//                   src={img3}
//                   alt=''
//                   className='h-[14rem] md:h-[30rem] object-cover w-full'
//                 />

//                 <div className='absolute top-0 p-4 md:p-8 bg-black h-full w-full bg-opacity-30'>
//                   <div className='flex  h-full  items-end'>
//                     <div className='text-white font-bold text-xl'>
//                       <h1 className='border-b-2 border-b-green-500'>
//                         Blog Post 1
//                       </h1>
//                       <h2 className='text-sm'>
//                         Lorem ipsum dolor sit amet consectetu
//                       </h2>
//                     </div>
//                   </div>
//                 </div>
//               </Link>
//             </div>
//           </div>

//           <div className='grid grid-cols-2 w-full gap-4'>
//             {/* post 4  */}
//             <div className=' hover:scale-95 transition duration-1000 ease-in-out h-[14rem] md:h-[30rem] relative'>
//               <Link>
//                 <img
//                   src={img1}
//                   alt=''
//                   className='h-[14rem] md:h-[30rem] object-cover w-full'
//                 />

//                 <div className='absolute top-0 p-4 md:p-8 lg:p-14 bg-black h-full w-full bg-opacity-30'>
//                   <div className='flex  h-full  items-end'>
//                     <div className='text-white font-bold text-xl'>
//                       <h1 className='border-b-2 border-b-green-500'>
//                         Blog Post 1
//                       </h1>
//                       <h2 className='text-sm md:text-lg'>
//                         Lorem ipsum dolor sit amet consectetu
//                       </h2>
//                     </div>
//                   </div>
//                 </div>
//               </Link>
//             </div>

//             {/* Post 5  */}
//             <div className=' hover:scale-95 transition duration-1000 ease-in-out h-[14rem] md:h-[30rem] w-full relative'>
//               <Link>
//                 <img
//                   src={img3}
//                   alt=''
//                   className='h-[14rem] md:h-[30rem] object-cover w-full'
//                 />

//                 <div className='absolute top-0 p-4 md:p-8 lg:p-14 bg-black h-full w-full bg-opacity-30'>
//                   <div className='flex  h-full  items-end'>
//                     <div className='text-white font-bold text-xl'>
//                       <h1 className='border-b-2 border-b-green-500'>
//                         Blog Post 1
//                       </h1>
//                       <h2 className='text-sm md:text-lg'>
//                         Lorem ipsum dolor sit amet consectetu{" "}
//                       </h2>
//                     </div>
//                   </div>
//                 </div>
//               </Link>
//             </div>

//             {/* post 6  */}
//             <div className=' hover:scale-95 transition duration-1000 ease-in-out col-span-2 h-[40rems] w-full relative'>
//               <Link>
//                 <img
//                   src={img2}
//                   alt=''
//                   className='h-[30rem] object-cover w-full'
//                 />
//                 <div className='absolute top-0 p-4 md:p-8 lg:p-14 bg-black h-full w-full bg-opacity-30'>
//                   <div className='flex  h-full  items-end'>
//                     <div className='text-white font-bold text-xl'>
//                       <h1 className='border-b-2 border-b-green-500'>
//                         Blog Post 1
//                       </h1>
//                       <h2>Lorem ipsum dolor sit amet consectetur </h2>
//                     </div>
//                   </div>
//                 </div>
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BlogSection;
